module.exports = __webpack_public_path__ + "img/Hero_Background_Desktop_v02.01ab9e4.webp";